class ProductBuyButtonsCarla {
  static init() {
    document.querySelectorAll('[data-buy-now]').forEach((button) => {
      if (button.dataset.carlaInit) return;
      button.dataset.carlaInit = 'true';

      button.addEventListener('click', async (event) => {
        event.preventDefault();

        const productForm = button.closest('product-form');
        if (!productForm || button.disabled) return;

        const form = productForm.querySelector('form');
        const sectionId = productForm.dataset.sectionId;
        const submitButton = sectionId ? document.getElementById(`ProductSubmitButton-${sectionId}`) : null;
        if (!form || submitButton?.disabled) return;

        button.setAttribute('aria-disabled', 'true');

        try {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = new FormData(form);

          const response = await fetch(`${routes.cart_add_url}`, config);
          const data = await response.json();

          if (data.status) {
            const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
            const errorMessage = productForm.querySelector('.product-form__error-message');
            if (errorWrapper && errorMessage) {
              errorWrapper.hidden = false;
              errorMessage.textContent = data.description;
            }
            return;
          }

          window.location.href = button.dataset.checkoutUrl || '/checkout';
        } catch (error) {
          console.error(error);
        } finally {
          button.removeAttribute('aria-disabled');
        }
      });
    });
  }

  static restoreAddToCartLabel(sectionId) {
    const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!button?.dataset.addToCartLabel || button.disabled) return;

    const span = button.querySelector('span');
    if (span) span.textContent = button.dataset.addToCartLabel;
  }

  static syncBuyNowButtons() {
    document.querySelectorAll('product-form[data-section-id]').forEach((productForm) => {
      const sectionId = productForm.dataset.sectionId;
      if (!sectionId) return;

      const submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const buyNowButton = document.getElementById(`ProductBuyNowButton-${sectionId}`);
      if (!submitButton || !buyNowButton) return;

      buyNowButton.disabled = submitButton.disabled;
      buyNowButton.toggleAttribute('aria-disabled', submitButton.disabled);
    });
  }
}

function initProductBuyButtonsCarla() {
  ProductBuyButtonsCarla.init();
  ProductBuyButtonsCarla.syncBuyNowButtons();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductBuyButtonsCarla);
} else {
  initProductBuyButtonsCarla();
}

document.addEventListener('product-info:loaded', initProductBuyButtonsCarla);

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    ProductBuyButtonsCarla.syncBuyNowButtons();
    if (data?.sectionId) {
      ProductBuyButtonsCarla.restoreAddToCartLabel(data.sectionId);
    }
  });
}
